import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltSectionMessage } from '@cae/cobalt-react/components/section-message';
import * as React from 'react';

import type { SubmitDocumentMessagesProps } from './SubmitDocumentMessages.types';

import styles from './SubmitDocumentMessages.module.css';

const SubmitDocumentMessages = React.memo(
  ({
    isSuccess,
    isError,
    onNavigateToSubmitted,
    onSubmitMore,
  }: Readonly<SubmitDocumentMessagesProps>): React.ReactElement | null => {
    if (isSuccess) {
      return (
        <CobaltSectionMessage
          data-testid="submit-success-message"
          variant="success"
          className={styles.submitDocumentMessage}
          sectionMessageTitle={<h3>Documents submitted to CAE successfully</h3>}
          sectionMessageDetails={
            <p>
              Go to{' '}
              <CobaltLink onClick={onNavigateToSubmitted} inline>
                Submitted documents
              </CobaltLink>{' '}
              to get more details.
            </p>
          }
          sectionMessageAction={
            <CobaltLink onClick={onSubmitMore}>
              Submit more documents?
            </CobaltLink>
          }
        />
      );
    }

    if (isError) {
      return (
        <CobaltSectionMessage
          data-testid="submit-error-message"
          variant="danger"
          className={styles.submitDocumentMessage}
          sectionMessageTitle={
            <h3>Submitting documents failed. Please try again.</h3>
          }
        />
      );
    }

    return null;
  }
);

SubmitDocumentMessages.displayName = 'SubmitDocumentMessages';

export { SubmitDocumentMessages };
